const CookiePolicy = () => {
  return (
    <div className="!py-4 text-white">
      <div className="container">
        <div>
          <p
            style={{
              textAlign: 'center',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              <strong>Cookies Policy</strong>
            </span>
          </p>
          <p
            style={{
              lineHeight: '115%',
              textAlign: 'center',
              background: 'transparent',
              marginBottom: '0.14in',
            }}
          >
            <br />
            &nbsp;
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>At&nbsp;</span>[…]&nbsp;
            <span>
              (the "Website"), we use cookies to make your overall experience on our Website better.
              Specifically, we use cookies to:
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginLeft: '0.31in',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              - Store information for the time you are on the Website (called "Session Cookies")
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginLeft: '0.31in',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              - Store information to recognize your browser or device each time you visit (called
              "Persistent Cookies")
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginLeft: '0.31in',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>- Store your login and password information, if you choose to</span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginLeft: '0.31in',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>- Store your user settings, like audio and display settings</span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginLeft: '0.31in',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>- Analyze your behavior on our Website, so we can continue to improve</span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginLeft: '0.31in',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              - Allow others to advertise on our Website or track information about you to improve
              advertising to you
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              By using our Website or any of our services, you consent to our use of cookies. This
              Cookies Policy will explain what cookies are, how we use them, and what your rights
              are in relation to our use of cookies. We'll also discuss our third-party cookies and
              what they mean for you.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              <u>
                <strong>
                  <br />
                  &nbsp;What are cookies?
                </strong>
              </u>
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              Cookies are small files that are placed on your device to store information.
              Specifically, cookies are small strings of text used to store information that may
              concern you, your behavior on the web, your preferences, or your device. Cookies are
              mainly used to adapt the operation of the Website to your expectations, offering a
              more personalized browsing experience and memorizing the choices you made previously.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              There are various types of cookies. Cookies do not record or store any personal data
              from your device.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              <u>
                <strong>
                  <br />
                  &nbsp;How we use cookies
                </strong>
              </u>
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              Technical cookies, which can also sometimes be called HTML cookies, are used for
              navigation and to facilitate your access to and use of the site. They are necessary
              for the transmission of communications on the network or to supply services requested
              by you. The use of technical cookies allows the safe and efficient use of the Website.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              You can manage or request the general deactivation or cancelation of cookies through
              your browser. If you do this though, please be advised this action might slow down or
              prevent access to some parts of the Website.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              We also use cookies that are retransmitted by an analytics or statistics provider to
              collect aggregated information on the number of users and how they visit the Website.
              These are also considered technical cookies when they operate as described.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>Analytics may collect information through log data, such as:</span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginLeft: '0.31in',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>- internet protocol (IP) address;</span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginLeft: '0.31in',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>- type of browser and device;</span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginLeft: '0.31in',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>- operating system;</span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginLeft: '0.31in',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>- name of the Internet Service Provider (ISP);</span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginLeft: '0.31in',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>- country information</span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginLeft: '0.31in',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>- date and time of visit;</span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginLeft: '0.31in',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>- web page of origin (referral) and exit;</span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginLeft: '0.31in',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>- possibly the number of clicks.</span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              We don't use this information to identify you, but rather to understand usage trends
              on our Website.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              We use session cookies to keep track of how you browse on your visits to the Website.
              Temporary session cookies are deleted automatically at the end of the browsing session
              - these are mostly used to keep track of what you do from page to page, such as with
              online shopping, keeping track of what is in your cart.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              Persistent cookies, on the other hand, remain active longer than just one particular
              session. These help us recognize you.We also use them to store your login and password
              info, if you choose, and to store your user settings.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              Third-party cookies: We also utilize third-party cookies, which are cookies sent by a
              third-party to your computer. Persistent cookies are often third-party cookies. The
              majority of third-party cookies consist of tracking cookies used to identify online
              behavior, understand interests and then customize advertising for you.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              We use remarketing cookies, which place files on your browser or device to allow us to
              display advertisements to you on other websites.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              When these types of cookies are used, we will ask for your explicit consent.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <br />
            &nbsp;
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              <u>
                <strong>
                  <br />
                  &nbsp;Consent
                </strong>
              </u>
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              When you arrive to our Website, we will request your consent for cookies through a
              clearly visible cookie banner/ notice at the user’s first visit.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              <u>
                <strong>What can you do about cookies?</strong>
              </u>
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              If you want, you can prevent the use of cookies, but then you may not be able to use
              our Website as we intend. To proceed without changing the options related to cookies,
              simply continue to use our Website.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              You can also manage cookies through the settings of your browser on your device.
              However, deleting cookies from your browser may remove the preferences you have set
              for the Website, as well as preferences you've set for other websites.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              For further information and support, you can also visit the specific help page of the
              web browser you are using:
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginLeft: '0.31in',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              - Internet Explorer:
              http://windows.microsoft.com/en-us/windows-vista/block-or-allow-cookies
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginLeft: '0.31in',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              - Firefox:
              https://support.mozilla.org/en-us/kb/enable-and-disable-cookies-website-preferences
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginLeft: '0.31in',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              <span lang="it-IT">- Safari: http://www.apple.com/legal/privacy/</span>
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginLeft: '0.31in',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>- Chrome: https://support.google.com/accounts/answer/61416?hl=en</span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginLeft: '0.31in',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              <span lang="it-IT">
                - Opera: http://www.opera.com/help/tutorials/security/cookies/
              </span>
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              <u>
                <strong>
                  <br />
                  &nbsp;How to contact us
                </strong>
              </u>
            </span>
          </p>
          <p
            style={{
              lineHeight: '115%',
              textAlign: 'left',
              marginBottom: '0.14in',
              background: 'transparent',
            }}
          >
            <span>
              For any questions on our cookies policy, you can reach us at the following
              email:&nbsp;
            </span>
            <span>EMAIL</span>
          </p>
          <p style={{ lineHeight: '100%', textAlign: 'left', marginBottom: '0in' }}>
            <br />
          </p>
        </div>
      </div>
    </div>
  )
}

export default CookiePolicy
